import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import styles from './Logo.less';

const cx = classnames.bind(styles);

Logo.propTypes = {
  app: PropTypes.oneOf(['datadesk']),
};

export default function Logo({ app }) {
  return <span className={cx('logo', app)} />;
}
